import { useEffect, useState } from "react";
import axios from "axios";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ServiceOrderCard from "../Components/ServiceOrderCard";
import SEO from "../Components/SEO";
import { useTranslation } from "react-i18next";

const ServicesGuide = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    axios
      .get("/MunicipalityService/MunicipalityServicesGuide")
      .then((res) => {
        setIsLoading(false);
        setServices(res);
      })
      .catch((e) => {});
  }, []);
  if (isLoading) {
    return (
      <Box sx={{ mt: 15, textAlign: "center" }}>
        <CircularProgress size={80} />
      </Box>
    );
  }

  if (!services || services.length === 0) {
    return (
      <Box sx={{ mt: 15, textAlign: "center", p: 5 }}>
        <Typography variant="h5" color="text.secondary" sx={{ mb: 2 }}>
          {t('noServicesAvailable')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('tryAgainLater')}
        </Typography>
      </Box>
    );
  }

  return (
    <>
    <SEO title={t('servicesGuide')} />
    <Paper sx={{ p: 3, background: "#F9FAFC" }} elevation={5}>
      <Stack gap={3}>
        {services.map((svc) => {
          return (
            <Accordion key={svc.name}>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon color="primary" />}
              >
                <Typography
                  sx={{ fontWeight: "bold" }}
                  variant="h6"
                  color="primary.main"
                >
                  {svc.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid spacing={3} container>
                  {svc.publicServices.map((f) => (
                    <Grid item lg={4} md={6} xs={12} key={f.name}>
                      <ServiceOrderCard
                        pageName="/service-guide-details"
                        {...f}
                        groupName={svc.name}
                        name={f.name}
                      />
                    </Grid>
                  ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Stack>
    </Paper>
    </>
  );
};
export default ServicesGuide;
